import React, { lazy, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom"; // <-- useParams instead of useLocation

import Addington from "../../Components/Addington";
import Competition from "../../Components/Competition";
import LeaderBoard from "../../Components/LeaderBoard";
import RaceCardSlider from "../../Components/RaceCardSlider";
import Slider from "../../Components/Slider";
import Sponsor from "../../Components/Sponsor";
import WinningList from "../../Components/WinningList";
import HomeCenterSubSection from "../../Section/HomeCenterSubSection";
import Banner from "../Banner";
import CurrentSection from "../CurrentPost";
import HomeTabs from "./HomeTabs";

const Ads = lazy(() => import("../../Components/Ads"));

const HomeLayout = () => {

  const { id, date } = useParams();

  const { data: racecard, status } = useSelector((state) => state.racecard);
  const [raceCardData, setRaceCardData] = useState(null);

  const [activeTab, setActiveTab] = useState("Live");

  useEffect(() => {
    if (racecard && racecard.length > 0) {
      const matchedRace = racecard.find((rc) => rc._id === id);
      const dataToSet = matchedRace || racecard[0];
      setRaceCardData(dataToSet);
    }
  }, [racecard, id]);
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <Slider />
          </div>

          <div className="row secontabs">
            <div className="col-sm-9">
              <div className="row racesliderrow">
                {racecard?.length === 0 ? (
                  <></>
                ) : (
                  <>
                    <div className="col-sm-10">
                      <RaceCardSlider />
                    </div>
                    <div className="col-sm-2 Addingtondiv">
                      <Addington />
                    </div>
                  </>
                )}
              </div>

              <HomeTabs raceCardData={raceCardData} />
            </div>

            <div className="col-sm-3 sha-upsight">
              <CurrentSection setRaceCardData={setRaceCardData} />

              <div className="sha-scroll">
                <Competition />
                <LeaderBoard />
                <WinningList />
                <Sponsor />
              </div>
            </div>
          </div>

          <div className="row banns">
            <div className="col-sm-12 pre-next-btn-newone">
              <Banner />
              <HomeCenterSubSection />
            </div>
          </div>
        </div>
      </div>
    </React.Suspense>
  );
};

export default HomeLayout;
